




















































































import gql from 'graphql-tag';
import Vue from 'vue';
import { findKey, forEach, map, mapValues, reduce } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { BNav, BNavItem } from 'bootstrap-vue';
import { Location } from 'vue-router';

import LoadingSpinner from '@reciprocity/loading-spinner';
import ZenButton from '@reciprocity/button';

import UrlParamHandler from '@/components/listing/components/user_preferences/UrlParamHandler';

import InvalidState from './components/InvalidState.vue';
import ToDoListListing from './components/ToDoListListing.vue';
import ZeroState from './components/ZeroState.vue';
import { Category } from './types';

// TODO: Old modals in SPA
// eslint-disable-next-line
import { Portal } from 'portal-vue';
import ZenModalTrigger from '@/components/zen_modal/ZenModalTrigger.vue';
import { ToDoPageMixin } from './OldModalMixin';

export default Vue.extend({
  name: 'ToDoListPage',
  components: {
    BNav,
    BNavItem,
    InvalidState,
    LoadingSpinner,
    ZeroState,
    ZenButton,
    ToDoListListing,

    // Old modals
    ZenModalTrigger,
    Portal,
  },

  mixins: [
    UrlParamHandler,
    // Temporary solution for old modal support
    ToDoPageMixin,
  ],

  props: {
    categoryInput: {
      type: String,
      required: true,
    },
    objectTypeInput: {
      // Input to component comes from route param, which is in ModelMetaSchema.humanPlural form
      type: String,
      /**
       * Object type may be unspecified in URL, in which case redirect to first
       * object type with objects will occur.
       */
      default: undefined,
    },
  },
  data() {
    return {
      initialLoad: true,
      categoryMeta: {
        [Category.Done]: {
          name: 'done',
          title: 'Done',
        },
        [Category.Todo]: {
          name: 'todo',
          title: 'To-Do',
        },
        [Category.Upcoming]: {
          name: 'upcoming',
          title: 'Upcoming',
        },
      },
    };
  },
  computed: {
    ...mapGetters(['modelMeta', 'currentUser', 'csrfToken']),
    ...mapGetters('todoList', [
      'loadingState',
      'isInvalidState',
      'isInvalidCategoryState',
      'isValidState',
      'isValidZeroState',
      'category',
      'objectType',
      'objectTypeMeta',
      'categories',
      'objectTypes',
      'categoriesObjectCounts',
      'objectTypesObjectCounts',
      'categoryHasObjects',
      'objectTypeHasObjects',
    ]),
    loading() {
      return this.$apollo.queries.counts.loading;
    },
    firstObjectTypeWithObjects(): string | undefined {
      return findKey(this.objectTypesObjectCounts[this.category], (objectCount: number) => objectCount > 0);
    },
    categoriesNavigation() {
      const mapToTemplate = category => {
        const meta = this.categoryMeta[category];
        const name = meta.name;

        return {
          name,
          title: meta.title,
          linkTo: this.linkTo(name, this.objectType),
          objectCount: this.categoriesObjectCounts[name],
          isActive: name == this.category,
        };
      };

      return map(this.categories, mapToTemplate);
    },
    objectTypesNavigation() {
      const mapToTemplate = objectType => {
        const meta = this.modelMeta[objectType];
        const category = this.isInvalidCategoryState ? Category.Todo : this.category;

        return {
          name: meta.humanPlural,
          title: meta.titlePlural,
          linkTo: this.linkTo(category, meta.humanPlural),
          objectCount: this.objectTypesObjectCounts[category][meta.humanPlural],
          isActive: meta.humanPlural == this.objectType,
        };
      };

      return map(this.objectTypes, mapToTemplate);
    },
    objectTypeHasCreateNewButton() {
      return this.objectType != 'assessments';
    },
    listingId(): string {
      // TODO: was previously titleSingular, check if change can break anything
      return `${this.category}-${this.objectTypeMeta.humanSingular}`;
    },
    listings() {
      interface TodoListListingTemplate {
        category: string; // TODO: from enum
        objectType: string; // TODO: from enum
        context?: number; // TODO: rename to 'view'
        title?: string;
      }

      const listings: { [id: string]: TodoListListingTemplate } = {};

      if (this.category == 'todo') {
        if (this.contextHasObjects(this.objectTypeMeta.modelPlural, 1)) {
          listings[`${this.listingId}-context-1`] = {
            title: this.contextTitle(this.objectTypeMeta.titlePlural, 1),
            category: this.category,
            objectType: this.objectTypeMeta.titleSingular,
            context: 1,
          };
        }

        if (this.contextHasObjects(this.objectTypeMeta.modelPlural, 2)) {
          listings[`${this.listingId}-context-2`] = {
            title: this.contextTitle(this.objectTypeMeta.titlePlural, 2),
            category: this.category,
            objectType: this.objectTypeMeta.titleSingular,
            context: 2,
          };
        }
      } else {
        listings[this.listingId] = {
          category: this.category,
          objectType: this.objectTypeMeta.titleSingular,
        };
      }

      return listings;
    },
  },
  watch: {
    categoryInput: {
      immediate: true,
      handler(categoryInput) {
        if (!this.initialLoad) {
          this.resetUserPreferences();
        }

        this.setCategory(categoryInput);
      },
    },
    objectTypeInput: {
      immediate: true,
      handler(objectTypeInput) {
        if (!this.initialLoad) {
          this.resetUserPreferences();
        }

        this.setObjectType(objectTypeInput);
      },
    },
  },
  async created() {
    this.setPageTitle({ title: 'To-Do List', isNew: true });
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
      setPageTitle: 'setPageTitle',
    }),
    ...mapActions('todoList', [
      'openNewObjectModal',
      'setLoadingState',
      'setCategory',
      'setObjectType',
      'setCategoriesObjectCounts',
      'setObjectTypesObjectCounts',
    ]),
    hasNoObjectsRedirect() {
      if (this.objectType) return;

      const fallbackObjectType: string = 'tasks';
      const objectType: string = this.firstObjectTypeWithObjects ? this.firstObjectTypeWithObjects : fallbackObjectType;

      this.$router.replace({ name: 'toDoList', params: { objectType } });
    },
    listingContexts() {
      return {
        todo: {
          Tasks: {
            1: 'tasksToSubmit',
            2: 'tasksToReviewOrVerify',
          },
          Requests: {
            1: 'requestsToSubmit',
            2: 'requestsToReviewOrVerify',
          },
          Assessments: {
            1: 'assessmentsToVerify',
            2: 'assessmentsToComplete',
          },
        },
        // TODO: add for other categories
      };
    },
    getListingContext(objectType: string, context: number): string {
      return this.listingContexts()['todo'][objectType][context];
    },
    linkTo(category: string, objectType: string): Location {
      return { name: 'toDoList', params: { category, objectType } };
    },
    contextHasObjects(objectType: string, context: number): boolean {
      const todos = this.counts.edges[0].node.todos;
      const contextName: string = this.getListingContext(objectType, context);

      return todos[Category.Todo][contextName].totalCount;
    },
    // TODO: move into listing component
    contextTitle(objectType: string, context: number): string {
      const actionsToTakeGroups: { [key: string]: { [key: number]: string } } = {
        Tasks: {
          1: 'Submit',
          2: 'Review or Verify',
        },
        Requests: {
          1: 'Submit',
          2: 'Review or Verify',
        },
        Assessments: {
          1: 'Verify',
          2: 'Complete',
        },
      };
      const actionToTakeGroup: string = actionsToTakeGroups[objectType][context];

      return `${actionToTakeGroup} ${objectType}`;
    },
    async openModal(): void {
      const addedNewObject: boolean = await this.openNewObjectModal();

      if (addedNewObject) {
        this.refreshCounts();
        this.refreshListings(this.$refs);
      }
    },
    refreshCounts(): void {
      this.$apollo.queries.counts.refetch();
    },
    refreshListings(listingComponentsRefs): void {
      // TODO: consider alternative to refs
      forEach(listingComponentsRefs, listing => listing.length && listing[0].refresh());
    },
  },
  apollo: {
    counts: {
      fetchPolicy: 'network-only',
      query: gql`
        query ToDoListCounts($filter: JSONString!) {
          counts: search(type: Person, filter: $filter) {
            edges {
              node {
                id
                ... on Person {
                  todos {
                    todo {
                      tasksToSubmit {
                        totalCount
                      }
                      tasksToReviewOrVerify {
                        totalCount
                      }
                      requestsToSubmit {
                        totalCount
                      }
                      requestsToReviewOrVerify {
                        totalCount
                      }
                      assessmentsToVerify {
                        totalCount
                      }
                      assessmentsToComplete {
                        totalCount
                      }
                    }
                    upcoming {
                      tasks {
                        totalCount
                      }
                      requests {
                        totalCount
                      }
                      assessments {
                        totalCount
                      }
                    }
                    done {
                      tasks {
                        totalCount
                      }
                      requests {
                        totalCount
                      }
                      assessments {
                        totalCount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables() {
        const filter = {
          left: 'email',
          op: { name: '=' },
          right: this.currentUser.email.value,
        };

        return {
          filter: JSON.stringify(filter),

          // Watches these for changes and refetches
          category: this.category,
          objectType: this.objectType,
        };
      },
      result({ data }) {
        this.initialLoad = false;

        const counts = data.counts.edges[0].node.todos;

        const todoCounts = counts[Category.Todo];
        const upcomingCounts = counts[Category.Upcoming];
        const doneCounts = counts[Category.Done];

        // TODO: clean up
        const objectCounts = {
          [Category.Todo]: {
            tasks: todoCounts.tasksToSubmit.totalCount + todoCounts.tasksToReviewOrVerify.totalCount,
            requests: todoCounts.requestsToSubmit.totalCount + todoCounts.requestsToReviewOrVerify.totalCount,
            assessments: todoCounts.assessmentsToVerify.totalCount + todoCounts.assessmentsToComplete.totalCount,
          },
          [Category.Upcoming]: {
            tasks: upcomingCounts.tasks.totalCount,
            requests: upcomingCounts.requests.totalCount,
            assessments: upcomingCounts.assessments.totalCount,
          },
          [Category.Done]: {
            tasks: doneCounts.tasks.totalCount,
            requests: doneCounts.requests.totalCount,
            assessments: doneCounts.assessments.totalCount,
          },
        };

        const categoriesCounts = mapValues(objectCounts, objectCounts =>
          reduce(objectCounts, (categoryCount, objectCount) => categoryCount + objectCount, 0)
        );

        this.setCategoriesObjectCounts(categoriesCounts);
        this.setObjectTypesObjectCounts(objectCounts);

        this.hasNoObjectsRedirect();
      },
      error(error) {
        this.showAlert({
          type: 'error',
          // TODO: what's the proper naming here for all objects on the todo list?
          //       calling them todos of tasks seems confusing ...
          message: 'Could not load counts for To-Do List objects.',
        });
        throw error;
      },
    },
  },
});
